import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { translationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';

import { TagComboboxFieldSunrise } from 'src/app/shared/components/tags';

import { useCategoryTags } from './hooks/useCategoryTags';

export const CategoryTags: React.FC = () => {
	const { data, actions } = useCategoryTags();

	return (
		<div id="edit_topics" className="flex flex-col">
			<Text variant="body" size="small" className="mb-1">
				<Translate value="corgi.petition.edit.petition_data.tags.title_v2" />
			</Text>
			<TagComboboxFieldSunrise
				hideLabel
				inputLabel={translationKey('corgi.petition.edit.petition_data.tags.title_v2')}
				placeholder={translationKey('corgi.petition.edit.petition_data.tags.placeholder_v2')}
				selectedTagsLabel={translationKey('corgi.petition.edit.petition_data.tags.selected_tags_v2')}
				defaultSelectedTags={data.selectedTags}
				onSelect={actions.onSelect}
				onRemove={actions.onRemove}
			/>
		</div>
	);
};
